export const transmitterConfigsViewValidations = {
  data() {
    return {
      editTransmitterConfigRules: {
        power_profile_id: [
          {
            required: true,
            message: this.$t("powerProfiles.validations.enter_power_profile"),
            trigger: "blur",
          },
        ],
        execution_count: [
          {
            required: true,
            message: this.$t("powerProfiles.validations.enter_execution_count"),
            trigger: "blur",
          },
        ]
      },
    };
  },
};
